import { Link } from 'react-router-dom';

export interface KeywordMenuOption {
    title: string;
    onClick?: () => void;
    url?: string;
    isExternal?: boolean;
};

interface KeywordMenuProps {
    options: KeywordMenuOption[];
    onItemClick?: () => void;
}

const KeywordMenu = ({ options, onItemClick }: KeywordMenuProps) => {
    return (
        <div className="KeywordCell__menu-content">
            {options.map(({ title, onClick, url, isExternal }, index) => {
                const commonProps = {
                    className: "KeywordCell__menu-item",
                    children: title
                };

                const key = `${title}-${index}`;

                if (isExternal) {
                    return (
                        <a
                            key={key}
                            {...commonProps}
                            href={url}
                            target="_blank"
                            rel="noopener noreferrer"
                        />
                    );
                }
                else if (url) {
                    return (
                        <Link
                            key={key}
                            {...commonProps}
                            to={url}
                        />
                    );
                } else {
                    return (
                        <button
                            key={key}
                            {...commonProps}
                            onClick={() => {
                                onClick?.();
                                onItemClick?.();
                            }}
                        />
                    );
                }
            })}
        </div>
    );
};

export default KeywordMenu;
